module.exports = {
	"ajax": {
		"fail": "Request failed. Please reload the page and try again.",
		"fetchItemsFail": "Unable to fetch additional __itemType__."
	},
	"auction": {
		"bidEndDateInvalid": "The pre-bidding end date you provided for the auction is invalid.",
		"bidEndDateRequired": "You must provide the pre-bidding end date and time of the auction.",
		"bidStartDateInvalid": "The pre-bidding start date you provided for the auction is invalid.",
		"bidStartDateRequired": "You must provide the pre-bidding start date and time of the auction.",
		"dateRequired": "$t(errors::auction.startDateRequired)",
		"endDateInvalid": "The end date you provided for the auction is invalid.",
		"endDateRequired": "You must provide the end date and time of the auction.",
		"locationAddressRequired": "You must provide an auction location address.",
		"locationCityRequired": "You must provide an auction location city.",
		"locationPostalCodeRequired": "You must provide an auction location ZIP or postal code.",
		"locationRegionRequired": "You must provide an auction location region.",
		"nameRequired": "You must provide a name.",
		"notFound": "Auction not found. The requested auction doesn't exist.",
		"readOnly": "You are not allowed to modify the auction at this time.",
		"startDateInvalid": "The start date you provided for the auction is invalid.",
		"startDateRequired": "You must provide the start date and time of the auction."
	},
	"authentication": "Authentication error.",
	"bid": {
		"alreadyLeading": "You already have the leading bid.",
		"bidLimitExceeded": "You have exceeded your bid limit of __limit__ for a single lot.",
		"invalidAmount": "You must enter a valid bid amount.",
		"noBidPermissions": "You do not have sufficient permissions to bid in this auction.",
		"notAllowed": "Bidding is not allowed because either the bidding period is over, or the auction is live.",
		"purchaseLimitExceeded": "You have exceeded your purchase limit of __limit__ for a single auction.",
		"somethingWrong": "Something went wrong with your bid.",
		"tooLow": "Bid is too low."
	},
	"email": {
		"alreadyExists": "This email address is already used by another user.",
		"required": "You need to provide an e-mail address.",
		"invalid": "You need to provide a valid e-mail address."
	},
	"errorWithField": "Database error with field: __field__.",
	"genericError": "An unknown error has occured.",
	"invalidLogin": "Wrong username or password.",
	"item": {
		"nameRequired": "You must provide an name for the item."
	},
	"lot": {
		"notFound": "Lot not found. The requested lot doesn't exist."
	},
	"manyErrors": "The following errors have occured",
	"noDataReceived": "No data received.",
	"organization": {
		"accessInvitesEmailDuplicated": "The user associated with that e-mail address already has access to this organization.",
		"contactAddressRequired": "You must provide an address.",
		"contactCityRequired": "You must provide a city.",
		"contactCountryRequired": "You must provide a country.",
		"contactEmailInvalid": "You must provide a valid e-mail address.",
		"contactEmailRequired": "You must provide an e-mail address.",
		"contactPostalCodeRequired": "You must provide a postal code.",
		"contactRegionRequired": "You must provide a region.",
		"contactTelephoneRequired": "You must provide a telephone number.",
		"contactWebsiteInvalid": "You must provide a valid website address.",
		"friendlyIdRequired": "You must provide a friendly URL.",
		"nameRequired": "You must provide a seller name.",
		"notFound": "Seller not found. The requested seller doesn't exist.",
		"staffInvitesEmailDuplicated": "The user associated with that e-mail address already has access to this seller account."
	},
	"oneError": "The following error has occured",
	"phone": {
		"required": "You must provide a phone number."
	},
	"primaryEmailNotConfirmed": "You must confirm your e-mail address before being granted access to this feature.",
	"upload": {
		"invalidFile": "The uploaded file is invalid.",
		"tooLarge": "The file you want to upload is too large. (The maximum size is 10mb)",
		"wrongType": "You must upload a file that is either a JPG or a PNG."
	},
	"subscription": "Subscription error.",
	"subscriptionLimitReached": "The limits of the current subscription have been reached.",
	"unexpected": "An unexpected error related to __related__ occured. $t(general::pleaseTryAgain)",
	"userList": {
		"alreadyExists": "Another user list with the same name already exists.",
		"nameRequired": "You must provide a name for the user list.",
		"invalidEmail": "$t(errors::email.invalid)"
	},
	"user": {
		"emailRequired": "$t(errors::email.required)",
		"nameRequired": "$t(errors::auction.nameRequired)",
		"notFound": "User not found. The requested user doesn't exist.",
		"passwordRequired": "$t(password::pwFieldEmpty)",
		"phoneRequired": "$t(errors::phone.required)"
	},
	"wrongCurrentPassword": "Wrong current password."
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/errors.json5
// module id = 1929
// module chunks = 6